<template>
  <v-btn
    v-bind="{
      color: light
        ? midnighBlueLighten95
        : brandPrimary,
      height: 40,
      rounded: 'lg',
      variant: 'flat',
      ...$props,
      ...$attrs,
    }"
    :class="['dppl-auto-sized-button', light ? 'light' : '']"
  >
    <slot />
  </v-btn>
</template>
<script>
import { useColors } from '@/composables/colors';

export default {
  name: 'DpplAutoSizedButton',
  props: {
    light: { default: false, type: Boolean },
  },
  setup() {
    const { midnighBlueLighten95, brandPrimary } = useColors();

    return {
      midnighBlueLighten95,
      brandPrimary,
    };
  },
};
</script>
<style scoped lang="less">
.v-btn.v-btn--size-default {
  font-size: 16px;
  font-weight: 500;
  text-transform: initial;
}
.v-btn {
  background-color: @text-darkest;
  color: @white;
}
.v-btn.light {
  color: @text-darkest;
}
.v-btn:focus, .v-btn:hover .v-btn:hover::before, .v-btn::before {
  border-color: @text-darkest;
  background-color: @bg-brand-dark;
}
.v-btn:hover, .v-btn:focus, .v-btn:active {
  background-color: @bg-brand-dark !important;
}
.v-btn:hover, .v-btn:hover :deep(svg), .v-btn:hover :deep(svg path) {
  background-color: @bg-brand-dark;
  border-color: @brand-primary;
  fill: @icon-brand!important;
}
.v-btn:focus :deep(svg), .v-btn:focus :deep(svg path) {
  background-color: transparent;
  border-color: @text-darkest;
  fill: @icon-darkest !important;
}
.v-btn.success:hover{
  background-color: @basic-green !important;
  border-color: @basic-green;
}
</style>
